<template>
   <div class="topContainer">
      <div class="pageHeader">Our Programs</div>
      <div class="sectionInfo">
       <div class="sectionContent">
         <b-list-group horizontal="md">
         <b-list-group-item class="paragraphSection">
             <div class="sectionInfoTop">
             <div>The <span class="accentText">"Strong Dads"</span> program allows us to partner with local schools to educate and support fathers 
             (grandfathers, uncles, male guardians) in the role they play at schools, in their homes, and in the community at larger.
              Men of Courage International provides a couple of hours of inspiration and motivation for the fathers by providing an
               inspirational speaker, Q&amp;A, live entertainment, and activities that give them the tools they need to continue to grow 
               in their roles as men.
              </div>
             <div class="listItemsRed">
               <div class="bTitle">Feedback</div>
               <div class="listItem">"It was encouraging to see all the parents and grandparents here as one of the fellow fathers said, 'we need to help each other'"</div>
               <div class="listItem">"This event helped me as a dad to see the need and appreciate the importance of being there for my kids and other kids in our community."</div>
               <div class="listItem">"Tonight’s event made me aware of some things that I will change in the way I do things with my kids (structure).</div>
            </div> 
             <div class="listItemsBlue">
                <div class="bTitle">Communities Enriched by Strong Dads</div>
                <div class="listItem">Rolling Knolls Elementary - Anne Arundel County</div>
                <div class="listItem">Seven Oaks Elementary - Anne Arundel County</div>
             </div>
            </div>
            <div class="sectionInfoAlt">
              <b-list-group horizontal="md">
                <b-list-group-item><img :src="mccord" class="imgSize"/></b-list-group-item>  
                <b-list-group-item>
                  <div style="fontSize:1.2em"><font-awesome-icon icon="comment"/> Mrs. McCord of Rolling Knolls Elementary </div>
                  <div style="fontStyle: italic">Rolling Knolls held three 'Strong Dads' events in 18 months that included inspiring speakers, entertainment, team building activities, and small group discussion about how men can be more involved and present at our school and in the lives of their children.  Men of Courage has spearheaded the idea and identified speakers who volunteer to share their own journey as a parent or knowledge in their area of expertise related to raising emotionally healthy kids.  As a result we have seen more fathers and grandfathers visiting Rolling Knolls at lunch and with programs like Hero Boys at Rolling Knolls.  The importance of fatherhood together with the challenges for today's dads is an important discussion and appears to build a camaraderie among those who participate in these events.</div>
                </b-list-group-item>
              </b-list-group> 
            </div>
            <div class="sectionInfoInner">
            <div><span class="accentText">“Community and Family Enrichment Corp. of Maryland (CFEM)”</span> is a program
             that works with local businesses (non-profit and profit) and organizations to educate and strengthen community members by providing 
             and supporting events that foster strong relationships in the community through a poignant focus on families.</div>
             <div class="listItemsRed">
               <div class="bTitle">Feedback</div>    
               <div class="listItem">"The day was very well planned and the event organizers put much time and thought into creating an environment open and friendly to our families. This allowed us to interact in positive ways with our families and share important information. While it was relaxing, we felt that parents walked away with information to help their children be successful students.”-Principal</div>
               <div class="listItem">"The reunion held at Annapolis Middle School was an opportunity to share in each other’s successes and to observe the best in our amazing cluster! The performances, food and GREAT conversation was uplifting!”-Principal</div>
               <div class="listItem">“The Family Reunion event highlighted what is great about the Annapolis Cluster. The community really supports our students, families and schools. This was an awesome way to showcase our community!” –Teacher</div>
             </div>
              <div class="listItemsBlue">
               <div class="bTitle">Communities Enriched by CFEM</div>
              <div class="listItem">Annapolis Broadneck Cluster (14 Schools) - Anne Arundel County </div>
             </div>
            </div>
            <div class="sectionInfoAlt">
              <b-list-group horizontal="md">
                <b-list-group-item><img :src="kavan" class="imgSize"/></b-list-group-item>  
                <b-list-group-item>
                  <div style="fontSize:1.2em"><font-awesome-icon icon="comment"/> Major Kavan Lake of the Naval Academy</div>
                  <div style="fontStyle: italic">I had a great time speaking with the Dads, and not surprisingly, I left there feeling like I had learned something from the Dads that were present. It was a very cool give and receive kind of connection. It was nice to see the men getting together without age, race, political, or religious barriers, and we were focused on being better fathers...which in turn makes better families, and better communities. I left there identifying some of my short comings, that I need to work through as well. Amazing energy with great interaction. I hope I was able to reach some of the men...I know they reached me for sure.</div>
                </b-list-group-item>
              </b-list-group> 
            </div>
            <div class="sectionInfoInner">
              <b-list-group horizontal="lg">
                <b-list-group-item style='text-align: center;background-color: aliceblue;'>
                  <div class="sectionTitle">Past Speakers</div>
                  <div class="img-container"><img :src="ehrlich" class="imgSizeLg"/></div>
                </b-list-group-item>  
                <b-list-group-item>
                  <div class='rowEntry'>Bob Ehrlich, Former Governor of Maryland</div>
                  <div class='rowEntry'>Kavan Lake, Major at Naval Academy</div>
                  <div class='rowEntry'>Rob Levit, Musician and President of a non-profit for children</div>
                  <div class='rowEntry'>Dr. Brian Sullivan, Decorated brain surgeon</div>
                  <div class='rowEntry'>and many more...</div>
                 </b-list-group-item> 
                 <b-list-group-item style='text-align: center;background-color: #d1daea;border: 4px solid #000;'>
                  <div class="sectionTitle">Get Involved</div>
                  <div class="rowEntryAlt"><a href="mailto:drf@menofcourageinternational.org" target="_blank" ><font-awesome-icon icon="envelope-open"/> drf@menofcourageinternational.org (Darin Ford)</a></div>
                  <div class="rowEntryAlt"><a href="https://www.facebook.com/menofcourageonternational" target="_blank">Men of Courage International</a></div>
                  <div class="rowEntryAlt"><a href="https://www.facebook.com/groups/HFC.INTERNATIONAL/" target="_blank">Husbands &amp; Fathers of Courage</a></div>
                  <div class="rowEntryAlt"><a href="https://www.facebook.com/groups/SMC.INTERNATIONAL/" target="_blank">Single Men of Courage</a></div>
                 </b-list-group-item>
              </b-list-group> 
            </div>            
         </b-list-group-item>
         </b-list-group>
       </div> 
      </div>
   </div>
</template>
<script>
export default {
  data: function () {
     return { 
       rotary : require('@/assets/rotary.jpg'),
       kavan: require('@/assets/kavan.jpg'),
       mccord: require('@/assets/mccord.jpg'),
       ehrlich: require('@/assets/ehrlich.jpg')
     }
  }
}
</script>
<style scoped>
.topContainer{
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('~@/assets/logoBorder.jpg') no-repeat center center fixed;
    -moz-background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    height: 60px;
    width: 100%;
    position: relative;
    z-index: 2;
    border-bottom: 2px solid black;
    box-shadow: 1px 1px #111;
}
@media screen and (max-width: 449px){
 .imgSize {
   height: 230px;
   margin: 5px 5px;
   display: none;
 }
  .imgSizeLg {
   height: 250px;
   margin: 5px 5px;
 }
}
@media screen and (min-width: 450px){
 .imgSize {
   height: 230px;
   margin: 5px 5px;
   display: block;
 }
  .imgSizeLg {
   height: 270px;
   margin: 5px 5px;
 }
}
.img-container {
  text-align: center;
  display: block;
}
.paragraphSection{
   margin-left: 10px;
  /* text-indent: 2em; */
   margin-top: 5px;
   color: #332e2f;
}
.sectionTitle{
  font-size: 1.3em;
  white-space: nowrap; 
  font-weight: bold;
  padding: 10px;
}
.bigText{
  font-size: 1.4em;
}
.bTitle{
  font-weight: bold;
}
.rowEntry{
  border: 1px solid #ccc;
  margin: 5px;
  padding: 5px;
  background-color: #f0f0f0;
}
.rowEntryAlt{
  border: 1px solid #3f7edd;
  border-radius: 4px;
  margin: 15px;
  padding: 5px;
  text-align: left;
  background-color: #f0f0f0;
}
.rowEntryAlt:hover{
    box-shadow: 2px 2px 2px navy;
    cursor: pointer;
}

.listItemsRed, .listItemsBlue{
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 5px;
  margin: 10px
}
.listItemsRed{
  background-color: #dabbbb
}
.listItemsBlue{
  background-color: lightblue
}
.listItem{
  margin-left:10px;
}
.listItem::before{
  content: '* ';
  font-size: 1.2em;
  font-weight: bold;
}
.accentText{
  color: #851e26;
  font-weight: bold;
  font-size: 1.3em;
}
.accentItalic{
  color: #851e26;
  font-size: 1.1em;
  font-weight:bold;
  text-align: center;
  font-style:italic;
}
.sectionInfo, .sectionInfoAlt{
  border: 1px solid #ccc;
  padding: 15px;
  border-radius: 5px;
}
.sectionInfo{
  background-color: #f0f0f0;
  margin-top:27px;
}
.sectionInfoAlt{
  background-color: rgb(62, 62, 96);
  margin: 10px;
}
.sectionInfoAlt div.list-group-item{
  color: #fff;
  background-color: rgb(62, 62, 96);
}
.sectionInfoRedBlur{
  margin: 10px;
  background-color: #f0f0f0;
  border-radius: 5px;
  border: 1px solid;
  padding: 10px;
  box-shadow: 5px 10px 18px #851e26;
}
.sectionContent{
  margin-top:0px;
}
</style>
